<app-form-input [label]="'execution'" [name]="getUid()+'_SepAtt_execution'" [parentForm]="parentForm" [rule]="''"
  [type]="'text'" [value]="marcheTravaux.execution">
</app-form-input>

<app-form-input [label]="'conceptionRealisation'" [name]="getUid()+'_SepAtt_conceptionRealisation'"
  [parentForm]="parentForm" [rule]="''" [type]="'text'" [value]="marcheTravaux.conceptionRealisation">
</app-form-input>